import React from 'react';
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import withStyles from "@material-ui/core/styles/withStyles";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { get } from 'lodash';

const CustomRadio = (props) => {
  const { classes, options, label } = props;
  const labelsArr = props.label.split(',');
  console.log('labelsArr', labelsArr)
  return (
    <div
      className={
        classes.checkboxAndRadio +
        " " +
        classes.checkboxAndRadioHorizontal + 
        ` ${props.readonly ? 'no-click' : ''} `
      }
    >
      <div style={{marginBottom:'-5px',marginTop:'20px'}}>{label.split(',')[0]}</div>
      <br style={{display:props.add_break_to_label ? 'block' : 'none'}} />
      {labelsArr.map((lar,i) => {
          if (i === 0) return null;
          const label = lar === 'Actual Days' ? 
            'Actual Days in a Month' 
          : 
            lar === 'Assignee & Lessor & Assignor' ? 
              'Assignee, Lessor & Assignor'
            : 
              props.showAssignors ? 
                lar === 'Lessee' ? 
                  'Assignee'
                :
                  lar
              :
                lar;

          const value = (options[i - 1] !== null || options[i - 1] !== undefined) ? options[i - 1] : '';
          return <FormControlLabel
            key={`rad-${i}`}
            control={
                <Radio
                  checked={props.value == options[i - 1]}
                  onChange={(e) => {
                    let checke = options[i - 1];
                    if (!isNaN(options[i - 1])) {
                      checke = parseInt(options[i - 1]);
                    }
                    props.onChange(e, checke, props.name);
                  }}
                  value={value}
                  name={props.name}
                  aria-label="A"
                  icon={
                    <FiberManualRecord
                      className={classes.radioUnchecked}
                    />
                  }
                  checkedIcon={
                    <FiberManualRecord
                      className={classes.radioChecked}
                    />
                  }
                  classes={{
                    checked: classes.radio
                  }}
                />
            }
            classes={{
              label: classes.label
            }}
            label={label}
          />
      })}
      
  </div>
  );
}

export default withStyles(regularFormsStyle)(CustomRadio);
